import { render } from "./KnowledgeLibrary.vue?vue&type=template&id=2a59d546&scoped=true"
import script from "./KnowledgeLibrary.vue?vue&type=script&lang=js"
export * from "./KnowledgeLibrary.vue?vue&type=script&lang=js"

import "./KnowledgeLibrary.vue?vue&type=style&index=0&id=2a59d546&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a59d546"]])

export default __exports__